import { BaseEvent, EventCategory, EventProperties } from '@lendi/analytics-web';

import { lendiAnalytics } from './analytics';
import { eventTracking } from './base';

// Radio button event
const RADIO_BUTTON_SELECT = 'Radio Button Selected';
interface RadioButtonEvent extends EventProperties, BaseEvent {
  event_name: typeof RADIO_BUTTON_SELECT;
  category: EventCategory;
  title: string;
  selection: string;
}
export function radioButtonEventTracking(
  analytics: ReturnType<typeof lendiAnalytics>,
  props: Pick<RadioButtonEvent, 'title' | 'selection' | 'position'> & {
    path?: string;
    category?: EventCategory;
  }
) {
  eventTracking<RadioButtonEvent>(analytics, {
    event_name: RADIO_BUTTON_SELECT,
    category: EventCategory.FUNNELS,
    ...props,
  });
}
